import { contains } from 'underscore'
import EdfinityCookie from 'models/cookie'

export const userType = () =>
  _E.currentUser.type ||
  new EdfinityCookie({ namespace: 'guest' }).get('user_type', false)

export const isAdmin = () => _E.currentUser.role == 'admin'
export const isGuest = () => _E.currentUser.role == 'guest'
export const isEducatorOrTa = () => _E.currentUser.educator || _E.currentUser.ta
export const isEducator = () => _E.currentUser.educator
export const isStudent = () => !isGuest() && !_E.currentUser.educator
export const isTa = () => _E.currentUser.ta

export const isOperator = () =>
  ['admin', 'superoperator', 'support', 'operator'].includes(
    _E.currentUser.role
  )

export const isSuperOperator = () =>
  ['admin', 'superoperator', 'support'].includes(_E.currentUser.role)

export const isSupport = () =>
  ['admin', 'support'].includes(_E.currentUser.role)

export const isVerifiedEducator = () =>
  _E.currentUser.educator && _E.currentUser.state == 'verified_educator'

export const featureAccess = (feature) =>
  contains(_E.currentUser.features, feature)
